import React from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  Modal,
  ReceiptCheckBox as RCB,
} from "../../components";
import { Formik } from "formik";

const UpdateBusiness = ({
  closeModal,
  loading,
  currencyCodes,
  onSubmit,
  item,
  validationSchema,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText>Update Business Info</MimaText>
      <Formik
        initialValues={{
          tradingName: item.tradingName || "",
          email: item.email || "",
          mobile: item.mobile || "",
          businessMobile: item.mobile || "",
          instagramHandle: item.instagramHandle || "",
          facebookHandle: item.facebookHandle || "",
          twitterHandle: item.twitterHandle || "",
          website: item.website || "",
          secondaryMobile: item.secondaryMobile || "",
          businessAddress: item.businessAddress || "",
          isInfluencer: item.isInfluencer || false,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <div className={styles.option}>
              <MimaText variant="small" mb={1}>
                Is the business for an Influencer?
              </MimaText>

              <div className="modal__beside">
                <RCB
                  title="Yes"
                  onChange={() => {
                    setFieldValue("isInfluencer", true);
                  }}
                  checked={values.isInfluencer}
                  value={values.isInfluencer}
                  name="isInfluencer"
                />
                <RCB
                  title="No"
                  onChange={() => {
                    setFieldValue("isInfluencer", false);
                  }}
                  checked={!values.isInfluencer}
                  value={!values.isInfluencer}
                  name="isInfluencer"
                />
              </div>
            </div>{" "}
            <>
              <MimaInput
                labelTitle="Trading Name"
                name="tradingName"
                type="text"
                value={values.tradingName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.tradingName}
                touched={touched.tradingName}
              />

              <MimaInput
                labelTitle="Email"
                name="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.email}
                touched={touched.email}
              />

              <MimaInput
                labelTitle="Mobile"
                name="mobile"
                type="tel"
                value={values.mobile}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.mobile}
                touched={touched.mobile}
              />

              <MimaInput
                labelTitle="Business Mobile"
                name="businessMobile"
                type="tel"
                value={values.businessMobile}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.businessMobile}
                touched={touched.businessMobile}
              />

              <MimaInput
                labelTitle="Instagram Handle"
                name="instagramHandle"
                type="text"
                value={values.instagramHandle}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.instagramHandle}
                touched={touched.instagramHandle}
              />

              <MimaInput
                labelTitle="Facebook Handle"
                name="facebookHandle"
                type="text"
                value={values.facebookHandle}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.facebookHandle}
                touched={touched.facebookHandle}
              />

              <MimaInput
                labelTitle="Twitter Handle"
                name="twitterHandle"
                type="text"
                value={values.twitterHandle}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.twitterHandle}
                touched={touched.twitterHandle}
              />

              <MimaInput
                labelTitle="Website"
                name="website"
                type="url"
                value={values.website}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.website}
                touched={touched.website}
              />

              <MimaInput
                labelTitle="Secondary Mobile"
                name="secondaryMobile"
                type="tel"
                value={values.secondaryMobile}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.secondaryMobile}
                touched={touched.secondaryMobile}
              />

              <MimaInput
                labelTitle="Business Address"
                name="businessAddress"
                type="text"
                value={values.businessAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.businessAddress}
                touched={touched.businessAddress}
              />
            </>
            <MimaButton
              title="Save"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default UpdateBusiness;
